export default "__VITE_ASSET__BEvRKD1h__"